import { IListaNegraModel } from "../interfaces/listanegra/IListaNegraModel";

export class ListaNegraModel implements IListaNegraModel {
    idListaNegra: number;
    idTipoDocumentoIdentidad: number;
    nroDocumentoIdentidad:string;
    nombres : string;
    apellidoPaterno: string;
    apellidoMaterno: string;
    motivoRegistro: string;
    fechaCreacion?: Date;
    registradoPor:string;
    idCompania: number;

    constructor(){
        this.idListaNegra=0;
        this.idTipoDocumentoIdentidad=0;
        this.nroDocumentoIdentidad="";
        this.nombres="";
        this.apellidoPaterno="";
        this.apellidoMaterno="";
        this.motivoRegistro="";
        this.registradoPor="";
        this.idCompania=0;
    }
}